
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import { type EarliestHomeworkSubmitCard } from '@xt/client/types/record-card'
import moment from 'moment'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class EarliestHomeworkSubmitCards extends Vue {
  @Prop() data: EarliestHomeworkSubmitCard
  @Prop({ default: true }) showRefreshBtn: boolean

  get MapNoon() {
    return '清晨'
  }

  get MinutesAndSecond() {
    return this.data.timeData ? moment(this.data.timeData).format('HH:mm') : 0
  }

  get Day() {
    return this.data.timeData ? moment(this.data.timeData).format('DD') : 0
  }

  get Month() {
    return this.data.timeData ? moment(this.data.timeData).format('MM') : 0
  }

  get Year() {
    return this.data.timeData ? moment(this.data.timeData).format('YYYY') : 0
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
